/**
 * K-366: Rücksprungziel („weiter“) nur innerhalb dieser Seite. „startsWith('/')“ allein reicht nicht: „/\\fremd.de“ behandelt der
 * Browser wie „//fremd.de“. Erlaubt ist nur ein Pfad, dessen aufgelöste Adresse denselben Ursprung hat.
 */
export function sichererPfad(path: string | null | undefined, fallback: string): string {
  if (!path || !path.startsWith("/") || path.startsWith("//") || path.includes("\\")) return fallback;
  try {
    const base = typeof window !== "undefined" ? window.location.origin : "https://app.creatoroffice.de";
    const u = new URL(path, base);
    return u.origin === base ? `${u.pathname}${u.search}${u.hash}` : fallback;
  } catch {
    return fallback;
  }
}
